import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRotate,
  faReply,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

import { ToolbarButton } from '../ToolbarButton';

export interface ProjectEditActionsProps {
  onReset: () => void;
  canReset: boolean;
  onUndo: () => void;
  canUndo: boolean;
  onDone: () => void;
  isSaving: boolean;
  /** Extra classes for the outer row. */
  className?: string;
}

/**
 * Reset / Undo / Done edit-session controls, shared by the top
 * `ProjectToolbar` (desktop) and the mobile bottom bar. All three share
 * the ghost styling so they read as one group; the ghost variant's
 * disabled treatment fades the icon + label to gray-400 when there's
 * nothing to reset/undo, keeping the layout stable.
 */
export const ProjectEditActions: React.FC<ProjectEditActionsProps> = ({
  onReset,
  canReset,
  onUndo,
  canUndo,
  onDone,
  isSaving,
  className = '',
}) => {
  return (
    <div className={`flex items-center justify-center gap-x-3 ${className}`}>
      <ToolbarButton
        variant="ghost"
        layout="iconLabel"
        title="Reset all changes since entering edit mode"
        onClick={onReset}
        disabled={!canReset}
      >
        <FontAwesomeIcon icon={faRotate} />
        <span>Reset</span>
      </ToolbarButton>
      <ToolbarButton
        variant="ghost"
        layout="iconLabel"
        title="Undo last fingering change in this edit session"
        onClick={onUndo}
        disabled={!canUndo}
      >
        <FontAwesomeIcon icon={faReply} />
        <span>Undo</span>
      </ToolbarButton>
      <ToolbarButton
        variant="ghost"
        layout="iconLabel"
        title="Save edits and exit edit mode"
        onClick={onDone}
        disabled={isSaving}
      >
        <FontAwesomeIcon icon={faCircleCheck} />
        <span>{isSaving ? 'Saving…' : 'Done'}</span>
      </ToolbarButton>
    </div>
  );
};
